import { Optional } from '~/@types/shared'
import { DEFAULT_LOCALE } from '~/lib/constants'

import { sfSearchProducts } from '@unlikelystudio/commerce-connector'

import {
  getCountryCode,
  getShopifyLanguageCodeFromLocale,
} from '~/utils/locales'

import { getStorePublicCredentials } from '../public-client'

export type TsfSearchProducts = { locale?: string } & Omit<
  Optional<Parameters<typeof sfSearchProducts>[1], 'variantsFirst'>,
  'id' | 'language'
>

export async function getSfSearchProducts({

  locale = DEFAULT_LOCALE,
  ...rest
}: TsfSearchProducts) {
  const credentials = getStorePublicCredentials()
  const lang = getShopifyLanguageCodeFromLocale(locale)
  const country = getCountryCode(locale)

  const shopifySearch = await sfSearchProducts(
    {
      storeUrl: credentials?.storeUrl,
      storefrontAccessToken: credentials?.storefrontAccessToken,
    },
    {
      metafieldKeys: rest?.metafieldKeys ?? [],
      language: lang,
      country,
      ...rest,
    },
  )

  return {
    results: shopifySearch?.products,
    nbHits: shopifySearch?.totalCount,
    pageInfo: shopifySearch?.pageInfo,
  }
}
